import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translation from '../../app/javascript/config/translations.json'

interface TranslationResources {
  en: {
    translation: typeof translation.en
  }
  ja: {
    translation: typeof translation.ja
  }
}

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: translation.en,
    },
    ja: {
      translation: translation.ja,
    },
  },
  lng: document.documentElement.lang,
  fallbackLng: document.documentElement.lang,
  interpolation: {
    prefix: '%{',
    suffix: '}',
  },
})

export default i18n
